import React from "react";
import { svg } from "../../../../../Assets/svg";
import { Modal } from "antd";
import { RootState, useAppSelector } from "../../../../../store";
import { BtnLoader } from "../../../../../Components/Components";

const ConfirmSplitModal: React.FC<{
  visible: boolean;
  setIsModalVisible: React.Dispatch<React.SetStateAction<boolean>>;
  onClose: any;
  handleSucess: any;
  isCopy: any;
}> = ({
  visible,
  setIsModalVisible,
  onClose,
  handleSucess,
  isCopy = false,
}) => {
  const { splitProductLoading } = useAppSelector(
    (state: RootState) => state.loading,
  );
  return (
    <Modal
      title={
         <div className="text-center fs-4 fw-bolder lh-m">
          {isCopy
            ? "Duplicate Qty for Another Department/Machine, Are You Sure?"
            : "Split Qty with Another Machine, Are You Sure?"}
        </div>
      }
      visible={visible}
      onCancel={onClose}
      width={"32.813rem"}
      closeIcon={svg.closeIcon}
      centered
      footer={
        <div className="d-flex justify-content-center gap-4">
          <button
            type="button"
            className="btn btn-lg btn-outline-secondary min-w-130"
            onClick={onClose}
            disabled={splitProductLoading}
          >
            CLOSE
          </button>
          <button
            type="submit"
            form="submitCreateMAchin"
            disabled={splitProductLoading}
            className={`btn btn-lg min-w-130 btn-primary`}
            onClick={handleSucess}
          >
            {splitProductLoading ? (
              <BtnLoader />
            ) : isCopy ? (
              "YES, DUPLICATE"
            ) : (
              "YES, SPLIT"
            )}
          </button>
        </div>
      }
      className="commonModalClass"
    >
      <div className="modal-body page-form">
        <p className="fs-6 d-flex justify-content-center mt-3 text-center text-4a4a4a">
          {" "}
          {isCopy
            ? "Duplicating the quantity will use for assign another Department/Machine. This action will update the production allocation. Please confirm before proceeding."
            : "Splitting the pending quantity will assign Product of it to another machine. This action will update the production allocation. Please confirm before proceeding."}
        </p>
      </div>
    </Modal>
  );
};

export default ConfirmSplitModal;
